import { Search } from 'lucide-react';
import ArticleCard from '../components/community/ArticleCard';
import ArticleModal from '../components/community/ArticleModal.tsx';
import { Article } from '../../../shared/types/index.ts';
import { useEffect, useState } from 'react';
import { Pagination } from '../components/shared/Pagination.tsx';
import { useSearchParams } from 'react-router-dom';
import LoadingSpinner from '../components/UI/LoadingSpinner.tsx';
import { EventTypeLabels, LECTURE_PAGE_TYPES } from '../../../shared/types/index.ts';

export default function Exhibits() {
    const ARTICLES_PER_PAGE = 6;
    const [selectedArticle, setSelectedArticle] = useState<Article  | null>(null);
    const [searchTerm, setSearchTerm] = useState<string>("");
    const [visibleArticles, setVisibleArticles] = useState<Article[]>([]);
    const [searchParams, setSearchParams] = useSearchParams();

    const page = Number(searchParams.get("page") || 1);
    const category = searchParams.get("category") || "";
    const search = searchParams.get("search");
    
    const [totalPages, setTotalPages] = useState<number>(1);
    const [loadingArticles, setLoadingArticles] = useState(false);
    debug(visibleArticles)
    const updateCategory = (category: string) => {
    setSearchParams(prev => {
        const params = new URLSearchParams(prev);
        params.set("category", category);
        params.set("page", "1");
        return params;
    });
    };

    const updatePage = (newPage: number) => {
    setSearchParams(prev => {
        const params = new URLSearchParams(prev);
        params.set("page", String(newPage));
        return params;
    });
    };

    const updateSearch = (searchTerm: string) => {
        setSearchParams(prev => {
            const params = new URLSearchParams(prev);
            params.set("search", String(searchTerm))
            params.set("page", "1");
            return params;
        })
    };

    useEffect(() => {
    const fetchArticles = async () => {
        setLoadingArticles(true);

        try {
        const params = new URLSearchParams({
            limit: String(ARTICLES_PER_PAGE),
            page: String(page),
        });

        if (category) params.append("category", category);
        // Always hide Education → Lectures content from Events (even when
        // filtering by a shared tag like Workshop).
        params.append("excludeCategories", LECTURE_PAGE_TYPES.join(","));
        if (search) params.append("search", search);

        const res = await fetch(`/api/articles?${params.toString()}`);
        
        if (!res.ok) {
            const resError = await res.json();
            throw new Error(resError.message);
        }

        const data = await res.json();

        debug("fetch", data);

        setTotalPages(data.totalPages);
        setVisibleArticles(data.articles);
        } catch (error) {
        console.error("Error fetching articles:", error);

        setVisibleArticles([]);
        setTotalPages(1);
        } finally {
        setLoadingArticles(false);
        }
    };

    fetchArticles();
    }, [page, category, search]);

    useEffect(() => {
        search && setSearchTerm(search);
    }, [search]);


    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
        updateSearch(searchTerm);
    }
    };

    const entries = Object.entries(EventTypeLabels)

    const rows = []
    for (let i = 0; i < entries.length; i += 4) {
    rows.push(entries.slice(i, i + 4))
    }
    rows[0].unshift(["", "All"])
    debug("ROWS", rows)
  return (
    <div className='bg-gradient-to-b from-[#E6F7F4] to-[#C5E8E3]'>
        <div className="max-w-7xl mx-auto px-4 py-16">
            <div className="flex flex-col gap-4">
                <div className='flex flex-col gap-4 items-center py-20'>
                    <h1 className="text-4xl font-bold ">Events</h1>
                    <p className="text-lg text-gray-600 ">Explore the BIOCAP team's community engagements</p>
                </div>
                <div>
                <div className='flex'>
                    <div className='relative w-full'>
                        <Search className='absolute left-3 translate-y-[60%] size-4 text-gray-400'/>
                        <input
                            type="text"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder={"Search news..."}
                            onKeyDown={handleKeyDown}
                            className="flex h-9 border placeholder:text-sm border-input bg-background px-3 py-2 text-base pl-10 w-full md:w-80 rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
                        />                    
                    </div>
                <div className="flex flex-col gap-3">
                {rows.map((row, i) => (
                    <div key={i} className="flex gap-3 items-start">
                    {row.map(([key, label]) => (

                        <button
                        key={key}
                        onClick={() => updateCategory(key)}
                        className={`inline-flex items-center whitespace-nowrap rounded-full text-sm px-4 py-2 font-bold ${
                            category === key
                            ? "bg-sensor text-white"
                            : "bg-white text-sensor hover:bg-blue-100 border border-gray-100"
                        }`}
                        >
                        {label}
                        </button>
                    ))}
                    </div>
                ))}
                </div>

                </div>
                {loadingArticles && <div className='my-[120px]'>
                    {<LoadingSpinner size={150} color='white'/>}
                </div>}

                {!loadingArticles && visibleArticles.length == 0 && 
                    <div className='flex flex-col justify-center items-center py-20'>
                        <p className='text-3xl '>
                            No articles match your search.        
                        </p>
                        <p className='text-gray-500 text-lg pt-2'>
                            Try adjusting your search or category filters.
                        </p>
                    </div>
                } 
                </div>
                {!loadingArticles && visibleArticles.length !== 0 && 
                <div className="grid grid-cols-3 gap-8 py-8">  
                    
                    {visibleArticles?.map((article) => (
                        <div  className='w-full' onClick={() => setSelectedArticle(article)}>
                            <ArticleCard 
                                article={article}
                            />
                        </div>

                    ))}
                </div>}
                <div>
                <Pagination
                    page={page}
                    totalPages={totalPages}
                    onPageChange={updatePage}
                />
                </div>
            </div>
            {selectedArticle && 
                <ArticleModal
                    article={selectedArticle}
                    setSelectedArticle={setSelectedArticle}
                />
            }
        </div>
    </div>

  );


}
